module.exports = __webpack_public_path__ + "static/media/c-vegan.3516d7ab.jpg";